import type {
  LoyaltyInfo,
  LoyaltyLevel,
  UsePointsResponse,
  LoyaltyHistoryResponse,
} from '../model/types'
import { useApi } from '@shared/api'

class APILoyalty {
  async getLoyaltyInfo(institutionId?: number | string): Promise<{ data: LoyaltyInfo }> {
    // Бэкенд /loyalty/info требует institution_id (из JWT ИЛИ query). У клиента в
    // токене его нет → без явной передачи бэк отвечает 400, и блок лояльности
    // молча не отрисовывается. Поэтому прокидываем id заведения параметром.
    const response = await useApi(true).get('/loyalty/info', {
      params: institutionId == null ? undefined : { institution_id: institutionId },
    });
    return {
      data: {
        points: Number(response.data.points) || 0,
        cashbackLevel: response.data.cashbackLevel || '3%',
        totalSpent: Number(response.data.totalSpent) || 0,
        pointsExpiryDate: response.data.pointsExpiryDate || null,
        daysUntilExpiry: Number(response.data.daysUntilExpiry) || 0,
        isExpiringSoon: Boolean(response.data.isExpiringSoon),
        expiryMessage: response.data.expiryMessage || '',
        lifetimeSpent: Number(response.data.lifetimeSpent) || 0,
        nextLevelInfo: response.data.nextLevelInfo ? {
          nextLevel: response.data.nextLevelInfo.nextLevel,
          requiredSpent: Number(response.data.nextLevelInfo.requiredSpent) || 0,
          remainingToSpend: Number(response.data.nextLevelInfo.remainingToSpend) || 0,
        } : null,
      },
    };
  }

  async usePoints(orderId: number, pointsToUse: number): Promise<UsePointsResponse> {
    const response = await useApi(true).post('/loyalty/use-points', {
      body: { orderId, pointsToUse },
    });
    return {
      success: response.data.success,
      newOrderTotal: Number(response.data.newOrderTotal),
      remainingPoints: Number(response.data.remainingPoints),
      ...(response.data.message && { message: response.data.message }),
    };
  }

  async getLoyaltyLevels(): Promise<{ data: LoyaltyLevel[] }> {
    const response = await useApi(true).get('/loyalty/levels');
    return {
      data: response.data.levels.map((level: any) => ({
        id: level.id,
        percent: level.percent,
        min_spent: Number(level.min_spent),
      })),
    };
  }

  async getLoyaltyHistory(page = 1, limit = 10): Promise<LoyaltyHistoryResponse> {
    const response = await useApi(true).get('/loyalty/history', {
      params: { page, limit },
    });
    return {
      history: response.data.history.map((item: any) => ({
        id: item.id,
        orderId: item.orderId,
        pointsChange: Number(item.pointsChange),
        balanceAfter: Number(item.balanceAfter),
        operationType: item.operationType,
        description: item.description,
        createdAt: item.createdAt,
        expiryDate: item.expiryDate,
      })),
      total: response.data.total,
      totalPages: response.data.totalPages,
      currentPage: response.data.currentPage,
    };
  }
}

const apiLoyaltyInstance = new APILoyalty();
export default apiLoyaltyInstance;
export { apiLoyaltyInstance as apiLoyalty };
